export default __webpack_public_path__ + "static/SportingGrotesque-Regular-d381b1eee855e79aaf01b629a47aab71.otf";